type MessageData = Record<string, unknown>;
type MessageCallback = (data: unknown) => void;

/** Standalone extension callback messaging (same contract as useExtensionUtil). */
export function extensionSendCBMessage(
  action: string,
  param: MessageData,
  callBack: MessageCallback
): void {
  const ids = Date.now() + Math.floor(Math.random() * 1000);
  const cparam: MessageData = { ...param, action, callbackId: ids };

  if (window.troveApp?.isExtension?.()) {
    if (!window.troveApp.extCallback) window.troveApp.extCallback = {};
    window.troveApp.extCallback[ids] = (data: unknown) => {
      callBack(data);
      delete window.troveApp!.extCallback![ids];
    };
    if (window.chrome?.runtime) {
      window.chrome.runtime.sendMessage(
        { action: 'extnCallBack', data: cparam },
        () => {
          void window.chrome?.runtime?.lastError;
        }
      );
    }
    return;
  }

  if (!window.troveApp?.listener) {
    window.troveApp = { ...window.troveApp, listener: {} };
  }
  const listener = window.troveApp!.listener!;
  if (!listener.postMessage) listener.postMessage = {};
  listener.postMessage[ids] = callBack;
  window.postMessage(
    {
      from: 'troves',
      action: 'postMessageCB',
      data: { callbackId: ids, action, param },
    },
    '*'
  );
}
